import React from 'react';
import { Tooltip, TooltipButton } from '@americanexpress/dls-react';
import IconClass from './IconClass';
import '../../../style/common.css';

const MousePopover = (props) => {
  let boolValue;

  return (
    <Tooltip
      onMouseOver={(e) => {
        e.preventDefault();
        if (e.currentTarget === e.target) {
          boolValue = true;
        } else {
          boolValue = false;
        }
      }}
      open={boolValue}
      triggerElement={<TooltipButton active="false" icon={<IconClass />} />}
    >
      <div className="new-line">{props.headingVal}</div>
      {props.textValue}
    </Tooltip>
  );
};

export default MousePopover;
